/* src/app/components/controls/sem-bound-tab-control/sem-bound-tab-content/sem-bound-tab-content.component.css */
/*# sourceMappingURL=sem-bound-tab-content.component.css.map */
